import { Button, CircularProgress, Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import { Else, If, Then } from "react-if";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import FetchLogin from "../components/Fetch/FetchLogin";
import t from "../Locale";
import { dateFormat, MonthsShort } from "../utils/functions";

const PaymentHistory = () => {
  const [v, setV] = useState({
    history: [],
    year: parseInt(dateFormat("Y")),
    month: parseInt(dateFormat("m")),
    loading: false,
  });
  const token = useSelector((state) => state.login.token);
  const hist = useHistory();
  const reqPaymentHistory = FetchLogin("balance-history", {
    data: {
      token: token,
      year: v.year,
      month: v.month,
    },
    callbackInit: () => {
      setV2({ loading: true });
    },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({ history: cb.response.data.BalanceHistory, loading: false });
      } else {
        setV2({ loading: false });
      }
    },
  });

  const setV2 = async (v2) => {
    await setV((prev) => ({ ...prev, ...v2 }));
  };

  const computeActiveDate = (month, year) => {
    if (v.month === month && v.year === year) {
      return "primary";
    }
    return "default";
  };

  useEffect(() => {
    reqPaymentHistory.handleTrigger();
    // eslint-disable-next-line
  }, [v.year, v.month]);

  return (
    <MainContainer
      render={
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TopBar leftSide="-1" title={t("Credit History")} />
          </Grid>
        </Grid>
      }
    >
      <If condition={v.loading}>
        <Then>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
              flexDirection: "column",
              fontSize: 24,
            }}
          >
            <CircularProgress />
            <br />
            <div>Loading...</div>
          </div>
        </Then>
        <Else>
          <div>
            {(() => {
              let d = new Date();
              d.setMonth(d.getMonth() - 6);
              return [...Array(6)].map((a, aI) => {
                d.setMonth(d.getMonth() + 1);
                let month = d.getMonth() + 1;
                let year = d.getFullYear();
                return (
                  <Button
                    key={aI}
                    size="small"
                    style={{ margin: "0 2px" }}
                    color={computeActiveDate(month, year)}
                    onClick={() => {
                      setV2({ year, month });
                    }}
                  >
                    {MonthsShort[d.getMonth()]}
                  </Button>
                );
              });
            })()}
          </div>
          {v.history?.length > 0 ? (
            <div className="payment-history">
              <div>
                <span>Date</span>
                <span>Description</span>
                <span>Debit</span>
                <span>Credit</span>
                <span>Balance</span>
              </div>
              {v.history.map((history, historyKey) => (
                <div key={historyKey}>
                  <span>
                    {dateFormat("d M Y", history.created_at).toUpperCase()}
                    <br />
                    {dateFormat("h:i A", history.created_at).toUpperCase()}
                  </span>

                  <span>
                    {history.desc.toUpperCase()}
                    {history.book_no !== undefined ? (
                      <div
                        style={{
                          backgroundColor: "transparent",
                          fontStyle: "italic",
                          fontSize: 14,
                          fontWeight: 100,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          hist.push("/check/" + history.book_no.toLowerCase());
                        }}
                      >
                        {history.book_no}
                      </div>
                    ) : null}
                  </span>
                  <span>{history.debit}</span>
                  <span>{history.credit}</span>
                  <span>{history.balance}</span>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                fontStyle: "italic",
                fontSize: 22,
                height: "80vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent",
              }}
            >
              <span>No Data</span>
            </div>
          )}
        </Else>
      </If>
    </MainContainer>
  );
};

export default PaymentHistory;
